import React from 'react';
import PracticeSetupPage from './PracticeSetupPage';

const InstitutionOnboardingPage = () => {
  return <PracticeSetupPage accountType="clinic" />;
};

export default InstitutionOnboardingPage;
